import { APP_VERSION, api } from './api';

// The iPad (iOS 12) is hard to attach a debugger to, so uncaught errors are shipped to the
// API log. Rate-limited client-side as well as server-side.
let sent = 0;
const MAX_PER_SESSION = 20;

export function report(level: 'error' | 'warning' | 'info', message: string, stack?: string): void {
  if (sent >= MAX_PER_SESSION) return;
  sent++;
  api
    .clientLog({
      level,
      message: String(message).slice(0, 2000),
      stack: stack ? String(stack).slice(0, 8000) : undefined,
      url: window.location.pathname,
      app_version: APP_VERSION,
      user_agent: navigator.userAgent,
    })
    .catch(() => undefined);
}

export function installErrorReporter(): void {
  // Hand over from the ES5 early reporter in index.html.
  const w = window as Window & { __obvEarlyError?: (e: ErrorEvent) => void };
  if (w.__obvEarlyError) window.removeEventListener('error', w.__obvEarlyError);
  window.addEventListener('error', (e) => report('error', e.message, e.error && e.error.stack));
  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    const r = e.reason as { message?: string; stack?: string } | undefined;
    report('error', (r && r.message) || String(e.reason), r && r.stack);
  });
}
